import React, { useEffect, useRef, useState } from 'react';

import { BarTask } from '@interfaces/ganttTasks/barTask';
import { GanttContentMoveAction } from '@interfaces/ganttTasks/ganttTaskActions';

import { EGanttTaskType } from '@enums/ganttTasks';

import Bar from './Bar';
import Milestone from './Milestone';

import style from './TasklList.module.scss';

export type TaskItemProps = {
	task: BarTask;
	arrowIndent: number;
	taskHeight: number;
	onEventStart: (
		action: GanttContentMoveAction,
		selectedTask: BarTask,
		event?: React.MouseEvent | React.KeyboardEvent
	) => any;
};

const TaskItem: React.FC<TaskItemProps> = ({
	task,
	arrowIndent,
	taskHeight,
	onEventStart,
}) => {
	const textRef = useRef<SVGTextElement>(null);
	const [taskItem, setTaskItem] = useState<JSX.Element>(<div />);
	const [isTextInside, setIsTextInside] = useState(true);

	useEffect(() => {
		if (task.type === EGanttTaskType.milestone) {
			setTaskItem(
				<Milestone task={task} />,
			);
		} else if (task.type === EGanttTaskType.task) {
			setTaskItem(
				<Bar task={task} />,
			);
		}
	}, [task]);

	useEffect(() => {
		if (textRef.current) {
			const textWidth = textRef.current.getBBox().width;
			const barWidth = task.x2 - task.x1;

			setIsTextInside(textWidth + 20 <= barWidth);
		}
	}, [textRef, task]);

	const getX = () => {
		const width = task.x2 - task.x1;
		const hasChild = task.barLinkedChildren.length > 0;
		if (isTextInside) {
			return task.x1 + 10;
		}

		return task.x1 + width + arrowIndent * +hasChild + arrowIndent * 0.2;
	};

	return (
		<g
			onClick={e => {
				onEventStart('click', task, e);
			}}
			onMouseEnter={e => {
				onEventStart('mouseenter', task, e);
			}}
			onMouseLeave={e => {
				onEventStart('mouseleave', task, e);
			}}
		>
			{taskItem}
			<text
				ref={textRef}
				className={
					isTextInside
						? style.barLabel
						: style.barLabel && style.barLabelOutside
				}
				x={getX()}
				y={task.y + taskHeight * 0.5}
			>
				{task.name}
			</text>
		</g>
	);
};

export default TaskItem;
